import React from 'react';

export default function Pagination({ page, total, limit, onPageChange }) {
  const totalPages = Math.ceil(total / limit);
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between mt-4 text-sm text-ink-muted">
      <span>{total} resultado{total !== 1 ? 's' : ''}</span>
      <div className="flex gap-2 items-center">
        <button className="btn btn-sm btn-secondary" disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}>Anterior</button>
        <span className="text-sm px-2">{page} / {totalPages}</span>
        <button className="btn btn-sm btn-secondary" disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}>Próximo</button>
      </div>
    </div>
  );
}
